import { useState } from 'react';
import { KurulumSatiri } from '../pwa/Pwa';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Parola değiştirme. Ayarlar ekranı FAZ 5'te geleceği için ayrı sayfa olarak
 * duruyor: kuruluşta herkese parola dağıtıldı, değiştirebilmeleri şart.
 * Parola değişince diğer cihazlardaki oturumlar kapanır (sunucu tarafı).
 */
export default function Parola() {
  const { logout } = useAuth();
  const [mevcut, setMevcut] = useState('');
  const [yeni, setYeni] = useState('');
  const [tekrar, setTekrar] = useState('');
  const [hata, setHata] = useState<string | null>(null);
  const [tamam, setTamam] = useState(false);
  const [bekliyor, setBekliyor] = useState(false);

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null);
    if (yeni !== tekrar) return setHata('Yeni parolalar birbirini tutmuyor');
    if (yeni.length < 8) return setHata('Yeni parola en az 8 karakter olmalı');

    setBekliyor(true);
    try {
      await api('/api/me/parola', { method: 'POST', body: JSON.stringify({ mevcut, yeni }) });
      setTamam(true);
      // Parola değişti; bu oturum da yenilenmeli.
      setTimeout(() => void logout(), 2500);
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Parola değiştirilemedi');
    } finally {
      setBekliyor(false);
    }
  }

  if (tamam) {
    return (
      <>
        <h1 className="ccd-title">Parola değişti</h1>
        <div className="ccd-banner">
          <span className="ccd-banner-icon" aria-hidden="true">✓</span>
          <div>
            <div style={{ fontWeight: 600 }}>Yeni parolan kaydedildi.</div>
            <div className="ccd-meta">
              Diğer cihazlardaki oturumların kapatıldı. Birazdan giriş ekranına döneceksin.
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <div className="ccd-eyebrow">Hesabım</div>
        <h1 className="ccd-title">Parola değiştir</h1>
      </div>

      <form className="ccd-card ccd-stack" style={{ maxWidth: 420 }} onSubmit={gonder}>
        <div className="ccd-field">
          <label className="ccd-field-label" htmlFor="m">Mevcut parola</label>
          <input id="m" className="ccd-input" type="password" autoComplete="current-password"
                 value={mevcut} onChange={(e) => setMevcut(e.target.value)} />
        </div>
        <div className="ccd-field">
          <label className="ccd-field-label" htmlFor="y">Yeni parola</label>
          <input id="y" className="ccd-input" type="password" autoComplete="new-password"
                 value={yeni} onChange={(e) => setYeni(e.target.value)} />
          <div className="ccd-field-hint">En az 8 karakter.</div>
        </div>
        <div className="ccd-field">
          <label className="ccd-field-label" htmlFor="t">Yeni parola (tekrar)</label>
          <input id="t" className="ccd-input" type="password" autoComplete="new-password"
                 value={tekrar} onChange={(e) => setTekrar(e.target.value)} />
        </div>

        {hata && (
          <div className="ccd-banner ccd-banner-danger">
            <span className="ccd-banner-icon" aria-hidden="true">!</span>
            <span>{hata}</span>
          </div>
        )}

        <button className="ccd-btn ccd-btn-primary" disabled={bekliyor}>
          {bekliyor ? 'Kaydediliyor…' : 'Parolayı değiştir'}
        </button>
      </form>

      {/* Kurulabilir panel: "Uygulamayı kur" satırı her rolde buradan erişilir (kurulum kartı susturulsa bile). */}
      <div style={{ maxWidth: 560 }}><KurulumSatiri /></div>
    </>
  );
}
